import { render, staticRenderFns } from "./mapbg2.vue?vue&type=template&id=58ec6bc6&scoped=true"
import script from "./mapbg2.vue?vue&type=script&lang=js"
export * from "./mapbg2.vue?vue&type=script&lang=js"
import style0 from "./mapbg2.vue?vue&type=style&index=0&id=58ec6bc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec6bc6",
  null
  
)

export default component.exports